import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const FadeUp = ({ children, delay = 0, y = 28, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.9, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
    <p
        className={`font-mono text-[11px] uppercase tracking-[0.3em] ${
            light ? "text-olive-light" : "text-olive"
        }`}
    >
        {children}
    </p>
);

export const MaskedLines = ({ lines, className = "", delay = 0 }) => (
    <h1 className={className}>
        {lines.map((line, i) => (
            <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
                <motion.span
                    className="block will-change-transform"
                    initial={{ y: "112%" }}
                    animate={{ y: 0 }}
                    transition={{
                        duration: 1.1,
                        delay: delay + i * 0.13,
                        ease: EASE,
                    }}
                >
                    {line}
                </motion.span>
            </span>
        ))}
    </h1>
);
